import addressModel from "@/models/address";
import {updateTotals} from "@/utils";
import defaultCart from "@/default-cart";
import SelloffService from "@/services/SelloffService";
import sellOffModel from "@/models/sellOff";

export const namespaced = true;

const localCart = JSON.parse(localStorage.getItem("cart"));
let _state,
  today = new Date().toISOString().substr(0, 10);
if (localCart) {
  _state = localCart;
} else {
  _state = defaultCart;
}

if (_state.date < today) {
  _state.date = new Date().toISOString().substr(0, 10);
}
export const state = _state;

export const mutations = {
  ADD_PRODUCT_IN_CART(state, cartProduct) {
    state.products.push(cartProduct);

    return cartProduct;
  },
  ADD_SELL_OFF(state, sellOff) {
    state.sellOff = sellOff;
  },
  EMPTY_CART(state) {
    const count = state.products.length;
    state.products.splice(0, count);

    // Update total to 0
    state.totalTtc = 0;
    state.totalWithoutDiscountTtc = 0;
    state.discountPercent = 0;
    state.sellOff = null;
  },
  INIT_CART(state) {
    const valuesFromHomepage = localStorage.getItem("sf_form_home") || null;
    if (valuesFromHomepage) {
      const obj = JSON.parse(valuesFromHomepage);
      state.numberOfDays = Number(obj.numberOfDays);
      state.date = obj.date;
      localStorage.removeItem("sf_form_home");
    }
  },
  REMOVE_PRODUCT_FROM_CART(state, productIndex) {
    const products = state.products;
    products.splice(productIndex, 1);
  },
  REMOVE_SELL_OFF(state) {
    state.sellOff = null;
  },
  SAVE_ADDRESS(state, data) {
    const _a = new addressModel();
    _a.hydrate(data)
    state.address = _a;
  },
  SAVE_DATE(state, date) {
    state.date = date;
  },
  SET_NUMBER_OF_DAYS(state, numberOfDays) {
    state.numberOfDays = Number(numberOfDays);
  },
  TOGGLE_WARRANTY(state) {
    state.warranty = !state.warranty;
  },
  UPDATE_TOTALS(state) {
    updateTotals(state);
  }
};

export const actions = {
  add({commit}, product) {
    commit("ADD_PRODUCT_IN_CART", product);
    commit("UPDATE_TOTALS");
    const cartProduct = [...state.products].pop();

    return Promise.resolve(cartProduct);
  },
  addSellOff({commit}, label) {
    return SelloffService
      .getSellOff(label)
      .then(result => {
        const sellOff = new sellOffModel();
        sellOff.hydrate(result.data.sellOff);
        if (sellOff.active) {
          commit("ADD_SELL_OFF", sellOff);
          commit("UPDATE_TOTALS");
        }

        return sellOff;
      });
  },
  removeSellOff({commit}) {
    commit("REMOVE_SELL_OFF");
    commit("UPDATE_TOTALS");
  },
  changeNumberOfDays({commit}, nb) {
    commit("SET_NUMBER_OF_DAYS", nb);
    commit("UPDATE_TOTALS");
  },
  empty({commit}) {
    commit("EMPTY_CART");
  },
  init({commit}) {
    commit("INIT_CART");
  },
  remove({commit}, product) {
    commit("REMOVE_PRODUCT_FROM_CART", product);
    commit("UPDATE_TOTALS");
  },
  toggleWarranty({commit}) {
    commit("TOGGLE_WARRANTY");
    commit("UPDATE_TOTALS");
  },
  updateTotals({commit}) {
    commit("UPDATE_TOTALS");
  },
  saveAddress({commit}, address) {
    commit("SAVE_ADDRESS", address);
  },
  saveDate({commit}, date) {
    return commit("SAVE_DATE", date);
  }
};

export const getters = {
  getAddress: state => () => JSON.parse(JSON.stringify(state.address)),
  getDate: state => () => state.date,
  getDateFormated: state => () => {
    let LOCALE = localStorage.getItem("selectedLocale") || "fr";
    return new Intl.DateTimeFormat(LOCALE).format(new Date(state.date));
  },
  getDiscountPercent: state => (digits) => {
    return state.discountPercent.toFixed(digits);
  },
  getNumberOfDays: state => () => {
    return state.numberOfDays;
  },
  getProducts: state => () => {
    return state.products;
  },
  getProductById: state => id => {
    return state.products.find(p => p.product.id === id);
  },
  getProductsCount: state => () => state.products.length > 0 ? state.products.length : 0,
  getSellOff: state => () => state.sellOff,
  getTotalTtc: state => (digits) => {
    // Number will remove unsignificant zeros
    return Number(state.totalTtc.toFixed(digits));
  },
  getTotalWithoutDiscountTtc: state => (digits) => {
    // Number will remove unsignificant zeros
    return Number(state.totalWithoutDiscountTtc.toFixed(digits));
  },
  getWarrantyTtc: state => (digits) => {
    let amount = 0;
    if (state.warranty) {
      amount = Number(state.products.length * state.warrantyDutyFree * (1 + state.tvaRate) * state.numberOfDays);
    }
    return Number(amount.toFixed(digits));
  }
};
